export default __webpack_public_path__ + "static/media/46.214c0fc5.jpg";